import React from 'react';
import classNames from 'classnames';
import FontAwesomeIcon from 'src/components/Icon';

interface SchedulingSlotSummaryProps {
  filterDay: string[];
  filterTab: string | null;
  selection: string[];
  onFilterTabSelect: (day: string) => void;
}

const SchedulingSlotSummary = ({
  filterDay,
  filterTab,
  selection,
  onFilterTabSelect,
}: SchedulingSlotSummaryProps) => {
  const slotsForActiveDay: string[] = selection.filter((entry: string) =>
    entry.includes(filterTab ?? '')
  );

  return (
    <>
      <div className="slot-tabs">
        {filterDay.map((day: string) => (
          <button
            type="button"
            key={day}
            onClick={() => onFilterTabSelect(day)}
            className={classNames('slot-tab', {
              'is-active': day === filterTab,
            })}
          >
            {day}
          </button>
        ))}
      </div>
      <div className="slot-list">
        {slotsForActiveDay.map((entry: string) => (
          <button
            type="button"
            key={entry}
            className="slot-option is-active"
          >
            <div className="slot-bullet">
              <FontAwesomeIcon glyph="check" weight="regular" />
            </div>
            {entry.replace(filterTab ?? '', '')}
          </button>
        ))}
      </div>
    </>
  );
};

export default SchedulingSlotSummary;